import { ApplicationError } from '@/api/ApplicationError';

/**
 * Represents a network error that occurs during an API request.
 * Intended to replace the more cryptic native TypeError: Failed to fetch.
 */
export class NetworkError extends ApplicationError {
  constructor(
    method: 'POST' | 'GET' | 'PUT' | 'PATCH' | 'DELETE',
    url: string,
    message = 'A network error has occurred',
  ) {
    message = `${message} [${method} ${url}]`;
    super(message);

    this.name = 'NetworkError';
    this.title = 'A network error has occurred';

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if ('captureStackTrace' in Error && typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}
